import { Component, Renderer2, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'ez-public',
    template: require('./public.component.html'),
    styles: [require('./public.component.less')],
    encapsulation: ViewEncapsulation.None
})
export class PublicComponent {

    constructor(
        private renderer: Renderer2
    ) {
        this.renderer.removeClass(document.body, 'member');
        this.renderer.addClass(document.body, 'public');
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/public/public.component.ts